// extracted by mini-css-extract-plugin
module.exports = {"template":"Template_template__eA2Hq"};